import DieMiniature from './DieMiniature';
import { getWarpOutline } from './portalWarpScene';
import './PortalWarp.css';

const PortalWarpFallback = ({ profile, dieId }) => {
  const points = Array.from({ length: 96 }, (_, i) => {
    const point = getWarpOutline(profile, (i / 96) * Math.PI * 2);
    return `${100 + point.x * 87},${100 + point.y * 87}`;
  }).join(' ');
  return (
    <div
      className={`portalWarpFallback warp-${profile.id}`}
      aria-hidden="true"
      style={{
        '--warp-primary': profile.primary,
        '--warp-secondary': profile.secondary,
      }}
    >
      <div className="portalWarpFallbackWell" />
      {profile.id === 'core' && <div className="portalWarpFallbackHorizon" />}
      {Array.from({ length: 15 }, (_, i) => (
        <svg
          key={i}
          className="portalWarpFallbackRing"
          viewBox="0 0 200 200"
          style={{
            '--ring-offset': `${-i * 0.16}s`,
            '--ring-turn': `${i * profile.twist * 60}deg`,
          }}
        >
          <polygon points={points} />
          <polygon
            points={points}
            transform="translate(100 100) scale(.94) translate(-100 -100)"
          />
        </svg>
      ))}
      <div className="portalWarpFallbackStars">
        {Array.from({ length: 24 }, (_, i) => (
          <i
            key={i}
            style={{
              '--streak-angle': `${i * 137.5}deg`,
              '--streak-offset': `${-i * 0.1}s`,
            }}
          />
        ))}
      </div>
      <div className="portalWarpFallbackDie">
        <DieMiniature dieId={dieId} />
      </div>
    </div>
  );
};

export default PortalWarpFallback;
